import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState
} from "react";
import { GraphGlobalFiltersCtx } from "../../graph-explorer/@types";
import { GraphController } from "../../graph-explorer/graph-controller";
import { GRAPH_INIT_GLOBAL_FILTERS } from "../../graph-explorer/defaults";

export const GraphEventContext = React.createContext<{
  updateSidebarDataEvent: unknown;
  notifyUpdateSidebarDataEvent: (props: unknown) => void;
  graphControllerCtx: GraphController | null;
  setGraphControllerCtx?: Dispatch<SetStateAction<GraphController | null>>;
  graphFiltersCtx?: GraphGlobalFiltersCtx;
  setGraphFiltersCtx?: Dispatch<
    SetStateAction<GraphGlobalFiltersCtx | undefined>
  >;
  allQueriesFinishedCtx: boolean;
  setAllQueriesFinishedCtx: Dispatch<SetStateAction<boolean | null>>;
} | null>(null);

export const useGraphEventContext = () => {
  const context = useContext(GraphEventContext);
  if (!context) {
    throw new Error(
      "Component using useGraphEventContext must be child of RelationshipsGraphEventProvider component."
    );
  }
  return context;
};

type Props = {
  children: ReactNode;
};
export const RelationshipsGraphEventProvider: React.FC<Props> = ({
  children
}) => {
  const [updateSidebarDataEvent, notifyUpdateSidebarDataEvent] = useState(null);
  const [graphControllerCtx, setGraphControllerCtx] = useState(null);
  const [graphFiltersCtx, setGraphFiltersCtx] = useState({
    nameFilter: "",
    setNameFilter: null,
    classificationFilters: GRAPH_INIT_GLOBAL_FILTERS.classificationFilters,
    setClassificationFilters: null,
    fileTypeFilters: {},
    setFileTypeFilters: null
  });
  const [allQueriesFinishedCtx, setAllQueriesFinishedCtx] = useState(false);
  return (
    <GraphEventContext.Provider
      value={{
        updateSidebarDataEvent,
        graphControllerCtx,
        setGraphControllerCtx,
        notifyUpdateSidebarDataEvent,
        graphFiltersCtx,
        setGraphFiltersCtx,
        allQueriesFinishedCtx,
        setAllQueriesFinishedCtx
      }}
    >
      {children}
    </GraphEventContext.Provider>
  );
};
